<template>
  <vs-input
    placeholder="Busque por nombre, alias, correo o rut"
    v-model.trim="text"
    icon="search"
    autofocus="true"
    class="w-100 pr-4"
    @keyup="searchUser"
    data-cy="search"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'SearchUsers',
  props: ['group'],
  data() {
    return {
      text: '',
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
    ]),
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getUsersGroup'
    ]),
    debounceFetchUsers: _.debounce(async function debounceFetchUsers() {
      if (!('id' in this.group)) {
        const query = {
          empresaId: this.company.id,
          filas: 20,
          filtro: this.text.toLowerCase()
        };
        await this.getUsersCompany(query);
      } else {
        const query = {
          empresaId: this.company.id,
          filas: 20,
          filtro: this.text.toLowerCase(),
          groupId: this.group.id
        };
        await this.getUsersGroup(query);
      }
    }, 500),
    async searchUser() {
      await this.debounceFetchUsers();
    }
  }
};
</script>

<style scoped>
::v-deep .vs-input--icon {
  font-size: 23px;
}
</style>
